module.exports = __webpack_public_path__ + "static/M5-1bab081a07a5bd878dfbc7760b132eb7.jpg";